module.exports = __webpack_public_path__ + "static/media/sub_location.bf4f8fd2.png";